import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { Component , Mixins, Prop } from 'vue-property-decorator';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { CourseViewerResponseSplitObjectMixin } 
  from '@/courses/mixins/course-viewer-response-split-object.mixin';
import CourseWhiteboardResponseMixin from '@/courses/mixins/course-whiteboard-response.mixin';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';

@Component({
  components: {
    EdFileViewer,
  }
})
export default class EdViewerResponseTypeObject extends Mixins(CourseViewerResponseSplitObjectMixin, CourseWhiteboardResponseMixin) {

  @Prop() readonly history: any;

  /* Hooks */ 
  beforeDestroy() {
    this.$edEventBus.$off(COURSES_EVENTS.SAVE_AND_CLOSE_HOMEWORK, this.sendFeedback);
  }

  created() {
    this.$edEventBus.$on(COURSES_EVENTS.SAVE_AND_CLOSE_HOMEWORK, this.sendFeedback);
    this.setFiles();
    this.setMenu();
    this.setMenuSplit();
  }

  mounted() {    
    if(this.canSendFeedback){
      this.callPdf(this.homeworkId, this.student.id);
    }else{
        this.cancelLoading();
    }
  }  
}
